import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import { Report018Container } from 'app/containers/Report/Report018'

const Report018PageCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.report_18)}</PageTitle>
      <Report018Container />
    </>
  )
}
const Report018Page = memo(Report018PageCpn, isEqual)

export default Report018Page
